import html2canvas from 'html2canvas';
import { post } from './queryPortal';
import { getRouteQuery } from './getRouteQuery';
import { getDateCreate } from '../../../src/utils/format';
import { loadFromStorageJSON, saveToStorage, saveToStorageJSON } from '../../../src/utils/storage';


function isJsonString(str) {
  try { JSON.parse(str); } catch (e) { return false; }
  return true;
}

const skipStats = () => {
  // if (window.location.href.includes('localhost')) return true;
  if (window.location.href.includes('test.maintstar.co')) return true;
  if (['model', 'mstar'].includes(root.app.profile)) return true;
  return false;
};

function getStoragePars() {
  const storagePars = {};
  // let keys = ['resizeRightProps/wo', 'resizeRightProps/asset', 'resizeRightProps/wr'];
  // keys = ['isMenuClosed', 'isMenuCustom', 'userStyling', 'userMenuFavorites', ...keys];
  // keys.forEach(d => { storagePars[d] = global.localStorage[d]; });
  storagePars.userID = root.app.userID;
  storagePars.portalID = root.app.portalID;
  storagePars.profile = root.app.profile;
  storagePars.platform = navigator.platform;
  storagePars.userAgent = navigator.userAgent;
  storagePars.screen = { innerWidth: window.innerWidth, innerHeight: window.innerHeight, width: window.screen.width, height: window.screen.height };
  return storagePars;
}

async function makeScreenshot() {
  const screenshotTarget = document.body;
  const canvas = await html2canvas(screenshotTarget);
  const base64image = canvas.toDataURL('image/png');
  const attachment = base64image.substring(base64image.indexOf(',') + 1);

  const res = await post('WR_ATTACH-Add.php', {
    data: attachment,
    file_name: 'error_screenshot.png',
    last_part: true,
    attach_code: 'error',
    attach_link_id: 999,
    file_size: '0.3',
    attach_id: 0,
    stats: 1,
  }, { skipError: true, skipLogging: true, skipIndicator: true, ignoreInvalidSession: true });
  return res.attach_id;
}

export async function statsAddError(errorType, errorInfo) {
  if (skipStats()) return;
  const json = isJsonString(errorInfo?.query?.body) && JSON.parse(errorInfo?.query?.body);
  if (json?.stats) return;
  console.log('errorInfo?.error', errorInfo);
  console.log('errorInfo?.error', errorInfo?.file);
  console.log('errorInfo?.error', errorInfo?.error);
  if (errorInfo?.file?.includes('SysStats') || errorInfo?.url?.includes('SysStats')) return; // prevent loop
  if (errorInfo?.error?.includes('Please logon first')) return;
  // if (error)
  // console.log('errorInfo:', errorInfo.url);

  // const savePics = !errorType.includes('security');
  const url = window.location.href;
  const savePics = true;
  let attach_id = null;
  let attach_id2 = null;
  if (navigator.onLine) {
    try {
      attach_id = savePics ? await makeScreenshot() : null;
      attach_id2 = savePics ? await makeScreenshot() : null;
    } catch { }
  }

  const error = {
    app: 'portal',
    event_type: errorType,
    profile: root.app.profile,
    url,
    date: getDateCreate('now'),
    error_code: errorInfo?.rc,
    attach_id,
    attach_id2,
    user_name: root.app.userID,
    recent_clicks: JSON.stringify(loadFromStorageJSON('recentClicks_desktop') || []),
    error: JSON.stringify(errorInfo),
    version: window.__version,
    config: JSON.stringify({
      skey: root.app.getToken() || '',
      portalID: root.app.portalID,
      screenId: root.location.pathname,
      routeQuery: getRouteQuery(),
      userID: root.app.userID,
      wg: root.app.userWorkgroup,
      platform: navigator.platform,
      userAgent: navigator.userAgent,
      connection: { downlink: navigator.connection?.downlink, effectiveType: navigator.connection?.effectiveType, saveData: navigator.connection?.saveData, rtt: navigator.connection?.rtt },
      onLine: navigator.onLine,
      screen: { innerWidth: window.innerWidth, innerHeight: window.innerHeight, width: window.screen.width, height: window.screen.height },
      events: loadFromStorageJSON('recentEvents_portal') || [],
    }),
  };
  // console.log('addError:', error, global.localStorage);
  post('WR_SysStats-Add.php', [error], { skipError: true, skipLogging: true, skipIndicator: true });
}
export function statsAddEvent(pars) {
  const events = global.localStorage.statsEvents ? JSON.parse(global.localStorage.statsEvents) : [];
  const { isMenuClosed, isMenuCustom, userStyling, userID, screen, wg } = getStoragePars();

  events.push({
    app: 'portal',
    event_type: pars.event,
    profile: root.app.profile,
    url: window.location.href,
    date: (new Date()).toISOString(),
    attach_id: null,
    config: { ...pars.config, isMenuClosed, isMenuCustom, userStyling, screen, userID, wg },
  });
  global.localStorage.statsEvents = JSON.stringify(events);
  // console.log('addEvent:', events, global.localStorage.userStyling);
}


function reportStats() {
  const events = JSON.parse(global.localStorage.statsEvents);
  const timer = JSON.parse(global.localStorage.statsTimer);
  global.localStorage.statsEvents = JSON.stringify([]);
  global.localStorage.statsTimer = JSON.stringify({ hour: (new Date()).getHours(), hourUTC: (new Date()).getUTCHours(), seconds: 0, screens: {} });

  // console.log('report:', global.localStorage);
  events.forEach(d => { d.config = JSON.stringify(d.config); });

  const trackTime = 1 && root.app.userID;
  let report = JSON.parse(JSON.stringify(events));
  if (trackTime) {
    report = [
      { app: 'portal',
        event_type: 'timer_portal',
        profile: root.app.profile,
        url: window.location.href,
        date: (new Date()).toISOString(),
        attach_id: null,
        config: JSON.stringify({
          ...timer,
          ...getStoragePars(),
          isPortal: true,
          connection: { downlink: navigator.connection?.downlink, effectiveType: navigator.connection?.effectiveType, saveData: navigator.connection?.saveData, rtt: navigator.connection?.rtt },
        }),
      },
      ...events,
    ];
  }
  post('WR_SysStats-Add.php', report, { skipError: true, skipLogging: true, skipIndicator: true });
}

function trackLastClick(ev) {
  let recentClicks = loadFromStorageJSON('recentClicks_portal') || [];
  if (!recentClicks?.length) recentClicks = [];

  if (!ev?.target) return;
  recentClicks.unshift({ target: ev.target?.outerHTML, date: (new Date()).toISOString() });
  recentClicks = recentClicks.slice(0, 15);
  saveToStorageJSON('recentClicks_portal', recentClicks);
}


export function startTrackTime() {
  // console.log('START_TRACK_TIME:');
  if (!root.app.statsAddError) return;
  if (skipStats()) return;

  global.document.addEventListener('click', trackLastClick, false);
  root.app.recentClicks = [];

  // console.log('start:', global.localStorage.statsTimer);
  if (!global.localStorage.statsEvents) global.localStorage.statsEvents = JSON.stringify([]);
  if (!global.localStorage.statsTimer) global.localStorage.statsTimer = JSON.stringify({ hour: (new Date()).getHours(), seconds: 0, screens: {} });
  if (!global.localStorage.statsReportTime) global.localStorage.statsReportTime = Math.round(Math.random() * 40);
  // console.log('initStats:', global.localStorage.statsReportTime);
  // reportStats();
  // console.log('screen:', window);

  function addTime(continueTimer) {
    saveToStorage('portalLastTimerTimestamp', (new Date()).getTime());

    const count = JSON.parse(global.localStorage.statsTimer).seconds;
    if (continueTimer) setTimeout(addTime, 3000);

    const { hourUTC } = JSON.parse(global.localStorage.statsTimer);
    const hourCurrent = (new Date()).getHours();
    const hourStorage = Number(JSON.parse(global.localStorage.statsTimer).hour);

    let minutesCurrent = (new Date()).getMinutes() + hourCurrent * 60;
    let minutesStorage = Number(global.localStorage.statsReportTime) + hourStorage * 60;

    if (hourCurrent < hourStorage) minutesStorage -= 24 * 60;

    // console.log('min:', minutesCurrent, minutesStorage, hourCurrent, Number(global.localStorage.statsReportTime));

    if (minutesCurrent - minutesStorage < 60) {
      global.localStorage.statsTimer = JSON.stringify({ hour: hourStorage, seconds: Number(count) + 3, screens: {}, hourUTC });
    } else {
      reportStats();
      console.log('REPORT PORTAL TIMER:', hourCurrent, hourStorage);
      // console.log('hours:', hourCurrent, hourStorage, minutesCurrent, minutesStorage, Number(global.localStorage.statsReportTime));
    }
  }

  function startTimer() {
    // console.log('focus', (new Date()).getHours(), global.localStorage.statsTimer);
    addTime(true);
  }
  function stopTimer() {
    addTime(false);
    // console.log('time:', global.localStorage.statsTimer);
  }
  window.addEventListener('focus', startTimer);
  window.addEventListener('blur', stopTimer);
  window.addEventListener('beforeunload', (e) => {
    stopTimer(false);
  });

  stopTimer();
  startTimer();
}
